import { cn } from '@/lib/utils/tw-merge';

type VehiclePriceBlockProps = {
    priceText: string;
    financeNote?: string;
    className?: string;
};

/** The price stays one text node — Merchant Center reads it from the page. */
export function VehiclePriceBlock({ priceText, financeNote, className }: VehiclePriceBlockProps) {
    return (
        <div className={cn('price-block price-block--card', className)}>
            <span className="price-block__price">{priceText}</span>
            {financeNote ? <span className="price-block__finance-note">{financeNote}</span> : null}
        </div>
    );
}
